import { useSelector} from 'react-redux'
import { Header } from './header'
import { GeneralSideBarBusinessFilter } from './generalSideBarBusinessFilter'
import { GroupsDetailedInformations } from './groupsDetailedInformations'
import { ProductsDetailedInformations } from './productsDetailedInformations'
import { RankingDetailedInformations } from './RankingDetailedInformations'
import { PaymentTypesDetailed } from './PaymentTypesDetailed'
import { MonthlyBalanceDetailedInformations } from './MonthlyBalanceDetailedInformations'
import { CouponDetailedInformations } from './CouponDetailedInformations'
import { PeriodFilter } from './PeriodFilter'
import {EarningsList} from './EarningsList'
import { ExpensesList } from './ExpensesList'
import { DailyBalanceDetailedInformations } from './DailyBalanceDetailedInformations'
import { CanceledOrders } from './CanceledOrders'

import { Container, Content } from './style'


export function CentralizedModal() {
    const openCentralizedModal = useSelector(state => state.modalCentralized)

    //const dispatch = useDispatch()

    return(
        <Container isOpen={openCentralizedModal.isOpen}>

            <Content isOpen={openCentralizedModal.isOpen}>

                <Header title={openCentralizedModal.title} />

                {
                    openCentralizedModal.componentToShow === 'generalBusinessFilter' ?
                    <GeneralSideBarBusinessFilter /> 
                    :
                    openCentralizedModal.componentToShow === 'groupsDetailedInformations' ?
                    <GroupsDetailedInformations />
                    :
                    openCentralizedModal.componentToShow === 'productsDetailedInformations' ?
                    <ProductsDetailedInformations />
                    :
                    openCentralizedModal.componentToShow === 'rankingDetailedInformations' ?
                    <RankingDetailedInformations />
                    :
                    openCentralizedModal.componentToShow === 'paymentTypesDetailed' ?
                    <PaymentTypesDetailed />
                    :
                    openCentralizedModal.componentToShow === 'periodFilter' ? 
                    <PeriodFilter />
                    :
                    openCentralizedModal.componentToShow === 'monthlyBalance' ?
                    <MonthlyBalanceDetailedInformations />
                    :
                    openCentralizedModal.componentToShow === 'couponDetailedInformations' ?
                    <CouponDetailedInformations />
                    :
                    openCentralizedModal.componentToShow === 'earningsList' ? 
                    <EarningsList/>
                    :
                    openCentralizedModal.componentToShow === 'expensesList' ? 
                    <ExpensesList/>
                    :
                    openCentralizedModal.componentToShow === 'dailyBalance' ?
                    <DailyBalanceDetailedInformations/>
                    :
                    openCentralizedModal.componentToShow === 'canceledOrders' ? 
                    <CanceledOrders/>
                    :
                    <></>
                }

            </Content>

        </Container>
    )
}

